export default "__VITE_ASSET__b1f05ce8__"